/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AttachmentSelectionDialog_emailForm = {
    readonly attachmentFolderSets: ReadonlyArray<{
        readonly key: string;
        readonly title: string;
        readonly folders: ReadonlyArray<{
            readonly slug: string;
            readonly entitySlug: string;
            readonly name: string;
            readonly attachments: ReadonlyArray<{
                readonly attachmentSlug: string;
                readonly " $fragmentRefs": FragmentRefs<"EntityAttachment_attachment">;
            }>;
        }>;
    }>;
    readonly " $refType": "AttachmentSelectionDialog_emailForm";
};
export type AttachmentSelectionDialog_emailForm$data = AttachmentSelectionDialog_emailForm;
export type AttachmentSelectionDialog_emailForm$key = {
    readonly " $data"?: AttachmentSelectionDialog_emailForm$data;
    readonly " $fragmentRefs": FragmentRefs<"AttachmentSelectionDialog_emailForm">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AttachmentSelectionDialog_emailForm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FolderSet",
      "kind": "LinkedField",
      "name": "attachmentFolderSets",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Folder",
          "kind": "LinkedField",
          "name": "folders",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entitySlug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EntityAttachment",
              "kind": "LinkedField",
              "name": "attachments",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "attachmentSlug",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EntityAttachment_attachment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmailFormResponse",
  "abstractKey": null
};
(node as any).hash = 'c778ca783241e60d521051765a19a440';
export default node;
